/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;overflow:hidden;display:block}.breakdowns-wrapper[_ngcontent-%COMP%]{margin:10px -10px 0}.breakdowns-wrapper[_ngcontent-%COMP%]   .breakdown[_ngcontent-%COMP%]{height:31px;display:flex;align-items:center;padding:0 8px;margin-bottom:5px}.breakdowns-wrapper[_ngcontent-%COMP%]   .breakdown[_ngcontent-%COMP%]   .breakdown-description[_ngcontent-%COMP%]{margin-left:8px;font-size:13px}.breakdowns-wrapper[_ngcontent-%COMP%]   .breakdown[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:30px;height:100%;margin-left:2px}"];
export { styles as styles };
